import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { payoutLineItemSchema, payoutLineItemListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import {
  loadingStart,
  loadingFinish,
  actionConfirmed,
} from 'app/ducks/loading/actions';
import {
  sagaActions,
} from 'app/ducks/payoutLineItems/actions';
import { PayoutLineItemsActionTypes as types } from 'app/ducks/payoutLineItems/types';

function* createPayoutLineItemSaga(action): any {
  yield put(sagaActions.createPayoutLineItemPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamPayoutLineItems.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, payoutLineItemSchema);

    yield put(sagaActions.createPayoutLineItemSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPayoutLineItemFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updatePayoutLineItemSaga(action): any {
  yield put(sagaActions.updatePayoutLineItemPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamPayoutLineItems.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, payoutLineItemSchema);

    yield put(sagaActions.updatePayoutLineItemSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePayoutLineItemFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* deletePayoutLineItemSaga(action): any {
  yield put(sagaActions.deletePayoutLineItemPending(action.payload.id));
  const [error, response] = yield (yield TeammoApi(yield select())).teamPayoutLineItems.delete(
    action.payload,
  );

  if (response || _.isEmpty(error)) {
    // const normalizedResponse = normalize(response, payoutLineItemSchema);
    yield put(sagaActions.deletePayoutLineItemSuccess(action.payload.id));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.deletePayoutLineItemFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getPayoutLineItemSaga(action): any {
  yield put(sagaActions.getPayoutLineItemPending());
  const [error, response] = yield (yield TeammoApi(yield select())).teamPayoutLineItems.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, payoutLineItemSchema);
    yield put(sagaActions.getPayoutLineItemSuccess(normalizedResponse));
    return normalizedResponse.entities.teamPayoutLineItems[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getPayoutLineItemFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllPayoutLineItemsSaga(action): any {
  yield put(
    sagaActions.getAllPayoutLineItemsPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.payoutLineItems.pagination))
    : action.payload.pagination;
  const teammoApi = TeammoApi(yield select());
  const [error, response] = yield (yield teammoApi).teamPayoutLineItems.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, payoutLineItemListSchema);

    yield put(
      sagaActions.getAllPayoutLineItemsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(error, sagaActions.getAllPayoutLineItemsFailed(_.isEmpty(error) ? {} : error.response.data.errors));
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPayoutLineItemSagaWatcher(): any {
  yield takeLatest(types.CREATE_PAYOUT_LINE_ITEM_REQUESTED, createPayoutLineItemSaga);
}

function* updatePayoutLineItemSagaWatcher(): any {
  yield takeLatest(types.UPDATE_PAYOUT_LINE_ITEM_REQUESTED, updatePayoutLineItemSaga);
}

function* deletePayoutLineItemSagaWatcher(): any {
  yield takeLatest(types.DELETE_PAYOUT_LINE_ITEM_REQUESTED, deletePayoutLineItemSaga);
}

function* getPayoutLineItemSagaWatcher(): any {
  yield takeLatest(types.GET_PAYOUT_LINE_ITEM_REQUESTED, getPayoutLineItemSaga);
}

function* getAllPayoutLineItemsSagaWatcher(): any {
  yield takeLatest(types.GET_ALL_PAYOUT_LINE_ITEMS_REQUESTED, getAllPayoutLineItemsSaga);
}

export default function* root(): any {
  yield all([
    createPayoutLineItemSagaWatcher(),
    updatePayoutLineItemSagaWatcher(),
    deletePayoutLineItemSagaWatcher(),
    getPayoutLineItemSagaWatcher(),
    getAllPayoutLineItemsSagaWatcher(),
  ]);
}
